jQuery(function(){

  //Scrollで要素表示した時点でclassを追加
  const sections = Array.prototype.slice.call(document.getElementsByClassName('js-addClass'));
  const waypoints = sections.map(section => {
    return new Waypoint({
      element: section,
      handler: function(direction) {
        section.classList.add('is-active');
        var nextEle = section.nextElementSibling;
        if(nextEle !== null){
          if(nextEle.classList.contains('js-addClass02')){
            setTimeout(function(){
              nextEle.classList.add('is-active');
            },200);
          }
        }
      },
      offset: '90%'
    });
  });

  //スムーススクロール
  $('a[href^="#"]').on('click', function () {
    var speed = 1000;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });

  function domFinished(){
    document.body.classList.add('is-loaded');
  }
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", domFinished, false);
  } else {
    domFinished();
  }


});
